import type { ChipTemplate } from '@/components/ui/template-chips';

// Preset appeal reasons surfaced as one-tap chips above the appeal textarea.
// The collector can click one to prefill the description and then edit
// before sending — or start from scratch. Each preset must be longer than
// APPEAL_MIN_CHARS so a tap alone is enough to clear validation.
export const COLLECTOR_APPEAL_TEMPLATES: ReadonlyArray<ChipTemplate> = [
  {
    id: 'confirm_author',
    label: 'Confirmo que es autor',
    text: 'Confirmo que sí es autor — sus publicaciones incluyen contenido propio relacionado con libros (portada, extractos, lecturas...). La IA se equivoca en este caso.',
  },
  {
    id: 'valid_publications',
    label: 'Publicaciones válidas',
    text: 'Tiene buenas publicaciones que sí encajan con Debook. Cumple los requisitos a pesar de lo que dice la IA.',
  },
  {
    id: 'category_change',
    label: 'Cambio de categoría',
    text: 'Encaja mejor en otra categoría distinta a la que la IA detectó (ver perfil / publicaciones recientes).',
  },
  {
    id: 'context_missing',
    label: 'Falta contexto',
    text: 'La IA no tiene contexto suficiente — el creador es relevante para Debook por motivos que requieren revisión humana.',
  },
];
